import { render, staticRenderFns } from "./ComunaDetalle.vue?vue&type=template&id=17bfb16c"
import script from "./ComunaDetalle.vue?vue&type=script&lang=js"
export * from "./ComunaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports